// extracted by mini-css-extract-plugin
export var downArrow = "_8u-0";
export var infoTooltipIcon = "_8u-3";
export var label = "_8u-1";
export var optionCard = "_8u-4";
export var upArrow = "_8u-2";